import "@/scss/reset.scss";
import styles from "./styles.scss";
import { FC, PropsWithChildren, useEffect } from "react";
import clsx from "clsx";
import { ANIMATION_DURATION } from "@/constants/drawer";

export const Layout: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--animation-duration",
      `${ANIMATION_DURATION}ms`,
    );
  }, []);

  return <div className={clsx(styles.container, className)}>{children}</div>;
};
